/** Default local model for CLAW skills and Studio V2 AI panels (Ollama tag). */
export const CLAW_DEFAULT_OLLAMA_MODEL = 'qwen2.5-coder:14b';
export const CLAW_DEFAULT_AI_PROVIDER = 'ollama';
export const CLAW_DEFAULT_AI_MODEL = CLAW_DEFAULT_OLLAMA_MODEL;
